import InfoOutlineIcon from '@mui/icons-material/InfoOutline'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Stack, Typography } from '@mui/material'
import { Markdown } from '../../Markdown'
import { useCiboAutoForm } from './CiboAutoFormContext'

const validationMarkdownOverrides = (color: string) => ({
  p: {
    component: Typography,
    props: { variant: 'caption', color, component: 'span', sx: { mb: 0 } },
  },
  span: {
    component: Typography,
    props: { variant: 'caption', color, component: 'span' },
  },
})

export const ValidationMessages = ({
  fieldName,
  error,
}: {
  fieldName: string
  error?: { message: string; keyword?: string }
}) => {
  const { warnings, touched, submitted } = useCiboAutoForm()

  const fieldError = error?.message
  const errorKeyword = error?.keyword
  const showError = !!fieldError && (touched[fieldName] || !!submitted)

  const fieldWarning = warnings?.[fieldName]
  const warningMessage = fieldWarning?.message
  const warningKeyword = fieldWarning?.keyword
  const showWarning = warningMessage && !showError && (touched[fieldName] || !!submitted)

  return (
    <>
      {showError && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          mt={0.5}
          data-testid={`validation-error-${fieldName}${errorKeyword ? `-${errorKeyword}` : ''}`}
        >
          <InfoOutlineIcon sx={{ fontSize: 14, color: 'error.main' }} />

          <Markdown
            color="error.main"
            typographyProps={{ component: 'span' as any }}
            overrides={validationMarkdownOverrides('error.main')}
          >
            {fieldError}
          </Markdown>
        </Stack>
      )}

      {showWarning && (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          mt={0.5}
          data-testid={`validation-warning-${fieldName}${
            warningKeyword ? `-${warningKeyword}` : ''
          }`}
        >
          <WarningAmberIcon sx={{ fontSize: 14, color: 'warning.main' }} />

          <Markdown
            color="warning.main"
            typographyProps={{ component: 'span' as any }}
            overrides={validationMarkdownOverrides('warning.main')}
          >
            {warningMessage}
          </Markdown>
        </Stack>
      )}
    </>
  )
}
